import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/HomeView.vue'),
    meta: {
      title: '植物介绍'
    }
  },
  {
    path: '/detail',
    name: 'detail',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/DetailView.vue'),
    meta: {
      title: '植物介绍'
    }
  },
  {
    path: '/base',
    name: 'baseIntroduction',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/BaseIntroduction.vue'),
    meta: {
      title: '基地介绍'
    }
  }
]

const router = new VueRouter({
  routes
})

export default router
